module.exports = __webpack_public_path__ + "img/twitter.b2f9971c.svg";